<div class="d-flex align-items-center justify-content-between row-layout" style="gap: 24px;">
    <ng-container *ngFor="let item of rowLayout.items">

        @if (isVisible(item.fieldName)) {

            <div class="d-flex flex-column" style="flex: 1 0 0;">

                <ng-container [ngSwitch]="item.type">
                    
                    <ng-container *ngSwitchCase="'HTML_ITEM'">
                        <div class="eac-c1">{{item.fieldLabel}}</div>
                        <div class="model-value eac-body-1 " style="overflow-wrap: anywhere;" [innerHTML]="toHtml(item).value | safe: 'html'" ></div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'TIME_ITEM'">
                        <div class="eac-c1">{{item.fieldLabel}}</div>
                        <div class="model-value eac-body-1 ">{{toTime(value[item.fieldName])}}</div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'DATEPICKER_ITEM'">
                        <div class="eac-c1">{{item.fieldLabel}}</div>
                        <div class="model-value eac-body-1 ">{{toDate(value[item.fieldName])}}</div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'MULTI_CHECKBOX_ITEM'">
                        <div class="eac-c1">{{item.fieldLabel}}</div>
                        <div class="model-value eac-body-1  d-flex flex-column">
                            <!-- [{{item.fieldName}}] -->
                            <!-- {{value[item.fieldName]|json}} -->
                            <div  *ngFor="let prop of keys(value[item.fieldName])" class="d-flex " style="gap:8px;">
                                <mat-icon *ngIf="value[item.fieldName][prop]==true" class="material-icons-outlined eac-c1">check_box</mat-icon>
                                <mat-icon *ngIf="value[item.fieldName][prop]==false" class="eac-c1">check_box_outline_blank</mat-icon>
                                <div>{{prop}}</div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'CHECKBOX_ITEM'">
                        <div class="d-flex model-value eac-body-1 " style="gap:8px;">
                            <ng-container *ngIf="value[item.fieldName]==true">
                                <mat-icon class="material-icons-outlined eac-c1">check_box</mat-icon>
                            </ng-container>
                            <ng-container *ngIf="value[item.fieldName]==false">
                                <mat-icon class="eac-c1">check_box_outline_blank</mat-icon>
                            </ng-container>
                            <div>
                                {{item.fieldLabel}}
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'TEXTAREA_ITEM'">
                        <div class="eac-c1">{{item.fieldLabel}}</div>
                        <div class="model-value eac-body-1 " style="overflow-wrap: anywhere;" [innerHTML]="emptyValue(value[item.fieldName]) | safe: 'html'"></div>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <div class="eac-c1">{{item.fieldLabel}}</div>
                        <div class="model-value eac-body-1 ">{{emptyValue(value[item.fieldName])}}</div>
                    </ng-container>
                    
                </ng-container>

            </div>

        }
        
    </ng-container>

</div>